// extracted by mini-css-extract-plugin
export default {"comment":"Comment_comment__-S4hs","commentHeading":"Comment_commentHeading__cBtCt","user":"Comment_user__LyAfT"};